import Vue from 'vue';

const cartItem =

    Vue.component('cart-item',
    {
        delimiters: ['@{','}'],

        template: `<div :key="item.key" class="headerCart__lineItem lineItem" :class="busy">
                <div class="lineItem__image">
                    <img v-if="hasImage(item)" :src="item.images[0].src" :alt="item.name" :title="item.name" />
                </div>
                <div class="lineItem__name ">
                    <span class="d-block noto-serif">@{ item.name }</span>
                    <span class="lineItem__name-variation" v-html="getColorVariation(item)"></span>
                </div>
                <div class="lineItem__qty">
                    <div class="formGroup">
                        <div class="formInputGroup formInputGroup--slim productQty">
                            <button type="button" class="btn decrease" @click="decreaseQty" :disabled="xhrActive">&mdash;</button>
                            <input v-model="qty" @change="updateQty" class="formInput" type="number" min="1" step="1" max="99" maxlength="2" required="required" />
                            <button type="button" class="btn increase" @click="increaseQty" :disabled="xhrActive">+</button>
                        </div>
                    </div>
                </div>
                <div class="lineItem__total">
                    <button type="button" aria-label="Fjern fra handlekurven" class="btnRmItem" @click="removeItem">
                        <span class="d-none">Fjern fra handlekurven</span>
                        <span class="fa-icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"><defs><clipPath><path d="M5.884,5,10,.884,9.116,0,5,4.116.884,0,0,.884,4.116,5,0,9.116.884,10,5,5.884,9.116,10,10,9.116,5.884,5Z" fill="#242424"/></clipPath></defs><g transform="translate(5 5)"><path data-name="icon color" d="M5.884,5,10,.884,9.116,0,5,4.116.884,0,0,.884,4.116,5,0,9.116.884,10,5,5.884,9.116,10,10,9.116,5.884,5Z" fill="#cc5a43"/></g></svg></span>
                    </button>
                    <span class="lineItem__total-price">@{ ( parseInt(item.totals.line_total) + parseInt(item.totals.line_total_tax)) |nok }</span>
                </div>
            </div>`,

        filters: {
            nok (value)
            {
                value = parseInt(value);

                if (!Number.isInteger(value)) {
                    return null;
                }

                value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                // return value + this.currency;
                return value + ',-';
            }
        },

        computed :
        {
            busy ()
            {
                return (this.xhrToken) ? 'busy' : '';
            }
        },


        watch :
        {
            item : function (val, oldValue) {
                if (this.item.quantity != this.qty) {
                    this.qty = this.item.quantity;
                }
            }
        },


        methods: {

            hasImage(item)
            {
                if (typeof item.images === 'object' && typeof item.images[0] === 'object' && typeof item.images[0].src === 'string') {
                    return true;
                } else {
                    return false;
                }
            },

            increaseQty()
            {
                this.qty = parseInt(this.qty);
                this.qty += 1;
                this.updateQty();
            },

            decreaseQty()
            {
                this.qty = parseInt(this.qty);

                this.qty = this.qty - 1;
                this.updateQty();
            },

            fixQty()
            {
                this.qty = (this.qty >= 1000) ? 999 : this.qty;

                // if there is a minQty over 0
                // and the qty is bigger than 0 but less minQty
                // then reset qty to minQty
                if (this.minQty > 0 && this.qty > 0 && this.qty < this.minQty) {
                    this.qty = this.minQty;
                }
            },

            removeItem()
            {
                this.qty = 0;
                this.updateQty();
            },

            updateQty()
            {
                if (this.xhrToken !== null) {
                    this.xhrToken.cancel();
                    this.xhrActive = false;
                    _log('cancel xhr...');
                }

                this.fixQty();
                const endpoint = (this.qty>0) ? this.restUpdate : this.restRremove;
                this.post(endpoint);
            },

            post (endpoint)
            {
                this.xhrToken = axios.CancelToken.source();

                const args = {
                    cancelToken : this.xhrToken,
                    key : this.cartItemKey,
                    quantity : this.qty,
                };

                const config = {
                    headers: {
                        'X-WC-Store-API-Nonce' : document.getElementById('wpnonce').content,
                    }
                };
                // _log(endpoint);
                // _log(args);

                this.xhrActive = true;
                axios.post(endpoint, args, config)
                    .then(this.post__callback)
                    .catch(function (error) { _log(error);});

            },

            post__callback (response)
            {
                this.$emit('cartitemuppated');
                this.xhrToken = null;
                this.xhrActive = false;
            },

            getColorVariation(item)
            {
                let variationName = null;
                // check if variation
                if (typeof item.variation === 'object' && item.variation.length) {
                    if (item.variation[0].attribute.toLowerCase()==='farge') {
                        variationName = item.variation[0].value;
                    }
                } else {
                    variationName = item.variationName;
                }

                return variationName;
            }
        },

        props : ['item'],

        data: function()
        {
          return {
            xhrToken : null,
            xhrActive : false,
            restUpdate :  '/wp-json/wc/store/cart/update-item',
            restRremove :  '/wp-json/wc/store/cart/remove-item',
            qty : this.item.quantity,
            cartItemKey : this.item.key,
            minQty : this.item.minQty
          }
        },

        created ()
        {
            this.qty = this.item.quantity;
        }

});

export { cartItem };
